export default "../css/d1f75e57d0335b9a129ecc2adcf7c536.ttf";